import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServicePortal {
    lookupService = new APIServiceLookUp();

    async getAllPortal(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}portal/getAllPortal`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getPortalById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}portal/getPortalById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updatePortal(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}portal/updatePortal`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updatePortalPage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}portal/updatePortalPage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setPortal(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}portal/setPortal`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delPortal(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}portal/delPortal`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}